// Node Modules
import { RichText } from 'prismic-reactjs';

// Themes
import theme from '@/themes/index';

const InformationCard = ({
  content: {
    title,
    cardContent, 
  },
  showTitle, 
  titleStyle = {},
}) => {
  return (
    <>
      <div className={'card-content'}
        id={'program-' + title.toLowerCase().replace(/\s/g, '-')}>
        {showTitle && <h4 style={titleStyle}>{title}</h4>}
        <RichText render={cardContent?.description} />
      </div>
      <style jsx>{`
        div.card-content {
          text-align: center;
        }

        div.card-content h4 {
          font-family: ${theme.fontFamilies.montserratBold};
          line-height: 1.5rem;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.card-content {
            text-align: left;
          }

          div.card-content h4 {
            line-height: 3.75rem;
            margin-block-start: 0;
            margin-block-end: 0;
            margin-inline-start: 0;
            margin-inline-end: 0;
            font-weight: bold;
          }
        }
      `}</style>
      <style global jsx>{`
        div.card-content p:not(.block-img) {
          font-family: ${theme.fontFamilies.montserrat};
          line-height: 1.7rem;
        }

        @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
          div.card-content p:not(.block-img) {
            font-size: 1.2rem;
            line-height: 1.7rem;
            margin: 1.5rem 0 0;
          }
        }
      `}</style>
    </>
  );
};

export default InformationCard;
